<script>
import appConfig from "@/app.config"
import Swal from "sweetalert2"

/**
 * Wallets component
 */
export default {
  page: {
    title: "Contextos",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      contextos: [],
      title: "Contextos",
      buscandoContextos: false,
      salvando: false,
      items: [
        {
          text: "Início",
          href: "/",
        },
        {
          text: "Master",
          href: "#",
        },
        {
          text: "Contextos",
          active: true,
        },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "descricao",
      sortDesc: false,
      fields: [
        {
          key: "descricao",
          label: "Descrição",
          sortable: true,
        },
        {
          key: "url",
          label: "URL",
          sortable: true,
        },
      ],
    };
  },
  computed: {

  },
  mounted() {
    this.getContextos();
  },
  methods: {
    getContextos() {
      this.buscandoContextos = true;
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/api/master/contextos", {
          headers: this.$headers,
        })
        .then((response) => {
          this.contextos = response.data
        })
        .catch((error) => {
          return this.$axiosCatch(error);
        })
        .finally(() => {
          this.buscandoContextos = false
        });
    },
    salvar() {
      if (!this.salvando) {
        this.salvando = true
        this.$axios
          .put(process.env.VUE_APP_API_URL + "/api/master/contextos",
            { contextos: this.contextos },
            { headers: this.$headers })
          .then((response) => {
            Swal.fire("Sucesso!", "Os contextos foram atualizados.", "success")
            return response
          })
          .catch((error) => { return this.$axiosCatch(error) })
          .finally(() => {
            this.salvando = false
          })
      }

    },
    adicionar(i) {
      this.contextos[i].contextos.push('')
    },
    remover(i, j) {
      this.contextos[i].contextos.splice(j, 1)
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-for="(contexto, i) in contextos" :key="i">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Contextos {{ contexto.descricao }}</h4>
            <div>
              <div v-for="(c, index) in contexto.contextos" :key="index" class="row">
                <div class="mb-1 col-lg-8">
                  <input v-model="contextos[i].contextos[index]" type="text" class="form-control" />
                </div>
                <div class="mb-3 col-lg-2">
                  <a class="btn btn-danger btn-block" value="Remover" @click="remover(i, index)">
                    <i class="bx bx-trash font-size-16 align-middle me-2"></i>
                    Remover
                  </a>
                </div>
              </div>
            </div>
            <a class="btn btn-info mt-3 mt-lg-0" value="Adicionar" @click="adicionar(i)">
              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
              Adicionar
            </a>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-3 col-lg-2">
              <a class="btn btn-success btn-block" @click="salvar()">
                <i :class="(salvando
                  ? 'bx bx-loader bx-spin font-size-16 align-middle me-2'
                  : 'bx bx-save font-size-16 align-middle me-2'
                )"></i>
                {{ salvando? 'Salvando...': 'Salvar' }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>